export default "__VITE_ASSET__DihG8Ris__"